import * as React from 'react'
const EventJournal = require('@procore/event-journal')

import { version } from '../../package.json'

// TYPES
interface ProviderProps {
  children: React.ReactNode
  client: any
}

interface ReporterParams {
  entryKey: string
  options?: object
}

// CLIENT
export const Client = EventJournal

const defaultClient = new Client({
  endpointUrl: '<URL Of EventJournal API Gateway>',
  logLevel: 0,
  eventDebounce: 1000,
  eventQueueSize: 500,
})

// HOOK

export const useUsage = ({ entryKey, options }: ReporterParams) => {
  const { client } = React.useContext(Context)

  client.entry && client.entry(entryKey, { ...options, version })
}

// DECORATOR

export const withUsage = ({ entryKey, options }: ReporterParams) => <
  T extends {}
>(
  Component: React.ComponentType<T>
) =>
  React.forwardRef((props: T, ref: any) => {
    useUsage({ entryKey, options })

    return <Component {...props} ref={ref} />
  })

// CONTEXT

export const Context = React.createContext({
  client: {
    entry: (entryKey: string, options: object) => {},
  },
})

export const Consumer = Context.Consumer

export const Provider = ({
  client = defaultClient,
  children,
}: ProviderProps) => (
  <Context.Provider value={{ client }}>{children}</Context.Provider>
)
